import React from 'react'

const SvgExpand = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.071 18.037a1 1 0 010 2H5a1 1 0 01-1-1v-5.073a1 1 0 112 0v4.073h4.071zM13.864 6a1 1 0 110-2h5.072a1 1 0 011 1v5.073a1 1 0 01-2 0V6h-4.072z'
    />
  </svg>
)

export default SvgExpand
